const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/skills.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
interface SkillsSearch {
  skill?: number;
}
const validateSearch = (search: Record<string, unknown>): SkillsSearch => {
  const skill = Number(search.skill);
  return Number.isFinite(skill) && skill > 0 ? {
    skill
  } : {};
};
export const Route = createFileRoute("/_protected/ai/skills")({
  validateSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});